let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");

let FormatTime = function(t){
	let time = esUtils.format_date(t, "h:MM TT");
	return time === "12:00 AM" ? null : dd.span({className: "time"}, time);
};

//These types keys correspond to the event object's
let itinerary_types = {
	Flight: {
		icon: "fa-plane",
		name: "Flight",
		form: require("./FlightForm"),
		toItinerary(flight){
			return {
				date: _.first(_.map(flight.legs, "legleave").sort()),
				custom: dd.div(null,
					flight.description,
					dd.div(null,
						_.map(_.sortBy(flight.legs, "legleave"), function(leg, i){
							return dd.div({key: i, style: {marginBottom: 10}},
								FormatTime(leg.legleave),
								dd.span({}, " depart "),
								leg.legfrom,
								dd.br(),
								FormatTime(leg.legarrive),
								dd.span({}, " arrive "),
								leg.legto
							);
						})
					)
				)
			};
		}
	},
	Hotel: {
		icon: "fa-building",
		name: "Hotel",
		form: require("./HotelForm"),
		toItinerary(hotel){
			return [
				{date: hotel.checkindate, description: "Check-in " + hotel.name},
				{date: hotel.checkoutdate, description: "Check-out " + hotel.name}
			];
		}
	},
	Ground: {
		icon: "fa-car",
		name: "Ground",
		form: require("./GroundForm"),
		toItinerary(ground){
			return {date: ground.starttime, description: ground.description};
		}
	}
};

let eventToDayItinerary = function(event){
	return _.map(_.groupBy(_.sortBy(_.filter(_.flattenDeep(_.map(itinerary_types, function(itinerary_attributes, type){
		return _.map(event[type], function(obj){
			let conv = itinerary_attributes.toItinerary(obj);
			return _.map(_.flattenDeep([conv]), function(item){
				item.id = obj.id;
				item.type = type;
				return item;
			});
		});
	})), function(item){
		return (-631134000 == item.date) || _.isDate(item.date);
	}), "date"), function(item){
		return esUtils.format_date(item.date, "yyyy-mm-dd"); //group by day
	}), function(legs){
		return {
			head: (-631134000 == legs[0].date) ? 'no date set' : esUtils.format_date(legs[0].date, "dddd, mmmm d, yyyy"),
			legs: _.sortBy(legs, "date")
		};
	});
};

let DayItinerary = dd.createClass({
	render(){
		let {itinerary, showForm, read_only} = this.props;

		return dd.div({className: "DayItinerary"},
			dd.div({className: "travel-head"},
				itinerary.head
			),
			_.map(itinerary.legs, function(leg, i){
				return dd.div({
						key: i,
						className: "travel-leg" + (read_only ? "" : " clickable"),
						onClick: read_only ? null : showForm(leg.type, leg.id)
					},
					dd.i({className: "fa fa-lg " + itinerary_types[leg.type].icon}),
					dd.div({className: "description"},
						leg.custom ? leg.custom : dd.span(null,
							FormatTime(leg.date),
							" " + leg.description
						)
					),
					dd.div({className: "clearfix"})
				);
			})
		);
	}
});

module.exports = dd.createClass({
	getInitialState(){
		return {show_form: {type: null, id: -1}};
	},
	__showForm(type, id){
		return _.bind(esUtils.wrapPreventDefault(function(){
			this.setState({show_form: {type: type, id: id}});
		}), this);
	},
	render(){
		let {event, Displaylists, read_only} = this.props;
		let {show_form} = this.state;
		let closeModal = this.__showForm(null, -1);

		return dd.div(null,
			dd.div({className: "panel panel-default"},
				dd.div({className: "panel-body"},
					_.map(eventToDayItinerary(event), function(itinerary, i){
						return DayItinerary({key: i, itinerary, showForm: this.__showForm, read_only});
					}, this),
					read_only ? null : dd.div({style: {marginTop: 30, textAlign: "center"}},
						dd.span({className: "btn-group"},
							_.map(itinerary_types, function(data, type){
								return dd.button({key: type, className: "btn btn-default btn-sm", onClick: this.__showForm(type, 0)}, dd.i({className: "fa " + data.icon}), " Add " + data.name);
							}, this)
						)
					)
				)
			),
			_.has(itinerary_types, show_form.type) ? Modal({
					title: (show_form.id > 0 ? "Edit" : "Add") + " " + itinerary_types[show_form.type].name,
					onClose: closeModal,
					buttons: []
				},
				itinerary_types[show_form.type].form({
					event: event,
					Displaylists: Displaylists,
					onCancel: closeModal,
					data: _.find(event && event[show_form.type], function(obj){
						return obj.id == show_form.id;
					}) || null
				})
			) : null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/travel/Itinerary.js